import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { useStateConfig } from '../hooks/useStateConfig';

export const LegacyDLSWrapper = ({ children }) => (
  <>
    <Helmet>
      <link
        rel="stylesheet"
        href="https://www.aexp-static.com/cdaas/one/statics/axp-dls/5.8.0/package/dist/styles/dls.min.css"
      />
    </Helmet>
    {children}
  </>
);

LegacyDLSWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export const DLSWrapper = ({ children }) => (
  <>
    <Helmet>
      <link
        rel="stylesheet"
        href="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.2/package/dist/6.25.2/styles/dls.min.css"
      />
    </Helmet>
    {children}
  </>
);

export const DLS7Wrapper = ({ children }) => (
  <>
    <Helmet>
      <link
        rel="stylesheet"
        href="https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.14.0/stylesheets/dls-max.min.css"
      />
    </Helmet>
    {children}
  </>
);

/**
 * Context:
 * Replacing React-Helmet with a side effect to append the script to the body
 * react-helmet removes all scripts and recreates them. This causes the script to be re-executed.
 * In the case of both dls script. this turn into a problem because
 * the script is re-executed and the dls is re-initialized.
 * for DLS icons it adds two svg definitions to the body. this causes duplicate ids on the page.
 * We want to avoid this by appending the script to the body directly.
 * ---
 * sideEffectAppendScriptToBody is a function that appends a script to the body
 * @param {string} src - the source of the script
 * @param {boolean} shouldDefer - should the script be deferred.
 * ---
 * It's named sideEffect because it has a side effect of appending the script to the body.
 */
export const sideEffectAppendScriptToBody = ({ src, shouldDefer }) => {
  const script = document.createElement('script');
  script.src = src;
  script.defer = shouldDefer;
  document.body.appendChild(script);
};

export const DLSScript = ({ children }) => {
  useEffect(() => {
    //  add the scripts to the end of the body via document.createElement and appendChild
    sideEffectAppendScriptToBody({
      src: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.5/package/dist/6.25.5/scripts/dls.min.js',
      shouldDefer: true,
    });
    // same thing for dls-icons
    sideEffectAppendScriptToBody({
      src: 'https://www.aexp-static.com/akamai/one/statics/@americanexpress/dls-icons/1.2.1/package/dist/browser/dls-icons.min.js',
      shouldDefer: true,
    });
  }, []);

  return children;
};

DLSWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

DLS7Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

DLSScript.propTypes = {
  children: PropTypes.node.isRequired,
};

export const PreloadbleFontsWrapper = ({ children }) => {
  const config = useStateConfig();

  if (!config.preloadableFonts?.length) return children;

  return (
    <>
      <Helmet>
        {config.preloadableFonts.map((fontHref) => (
          <link
            rel="preload"
            href={fontHref}
            key={fontHref}
            as="font"
            type="font/woff"
            crossOrigin="anonymous"
          />
        ))}
      </Helmet>
      {children}
    </>
  );
};

PreloadbleFontsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
